import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, combineLatest } from 'rxjs';
import { Faq } from '../shared/types/FaqDto';
import { FaqFilter } from '../shared/types/FaqFiltersDto';
import { FaqResponse } from '../shared/types/FaqResponseDto';

const FAQS_URL = '/talknow/faqs/30';

@Injectable({
  providedIn: 'root',
})
export class FaqService {
  private _filters$ = new BehaviorSubject<Array<FaqFilter>>([]);
  private _textFilter$ = new BehaviorSubject<string>('');
  private _articles$ = new BehaviorSubject<Array<Faq>>([]);

  private isInitialization = true;

  public get filters$() {
    return this._filters$.asObservable();
  }

  public get textFilter$() {
    return this._textFilter$.asObservable();
  }

  public get filteredArticles$() {
    return this._articles$.asObservable();
  }

  constructor(private http: HttpClient) {}

  getFaqs(selectedFilters = [], textFilter = '') {
    const activeTypes = selectedFilters.filter((f) => f.checked).map((f) => f.category);

    this.http
      .post<FaqResponse>(FAQS_URL, { types: activeTypes, keywords: textFilter })
      .subscribe((el) => this._articles$.next(el.articles));
  }

  initFaqsAndFilters() {
    this.http
      .post<FaqResponse>(FAQS_URL, { types: [], keywords: '' })
      .subscribe((el) => {
        const filters: Array<FaqFilter> = [];

        el.articles.forEach((article) => {
          article.articleCategory.split(';').forEach((category) => {
            const exists = filters.find((f) => f.category === category);
            if (!exists) {
              filters.push({ category, checked: false });
            }
          });
        });

        this._filters$.next(this.sortFilters(filters));
        this._articles$.next(el.articles);
        this.subscribeToFilters();
      });
  }

  private subscribeToFilters() {
    combineLatest([this.filters$, this.textFilter$]).subscribe(([filters, textFilter]) => {
      if (this.isInitialization) {
        this.isInitialization = false;
        return;
      }
      this.getFaqs(filters, textFilter);
    });
  }

  sortFilters(filters) {
    return filters.sort((a, b) => {
      let categoryA = a.category.toUpperCase();
      let categoryB = b.category.toUpperCase();

      if (categoryA < categoryB) {
        return -1;
      }
      if (categoryA > categoryB) {
        return 1;
      }
      return 0;
    });
  }

  onFilterChange(category: string) {
    const filters = this._filters$.value.map((f) => {
      if (f.category === category) {
        f.checked = !f.checked;
      }
      return f;
    });

    this._filters$.next(filters);
  }

  onTextFilterChange(textInput: string) {
    this._textFilter$.next(textInput);
  }
}



// WEBPACK FOOTER //
// ./ts/app/faq/faq.service.ts